import { getStrings, languageToggleHtml, wireLanguageToggleButtons } from "../../core/i18n";

// First-ever launch, before any provider is configured. Always shows the EN/CH
// toggle (no conditional needed, unlike providerList.ts's own empty state) — this screen only
// ever renders when there are zero providers in the first place (see taskpane.ts's routing), so
// there's no "providers already configured" state to hide it for.

export function renderOnboarding(
  container: HTMLElement,
  handlers: { onAddProvider: () => void; onChanged: () => void }
): void {
  const s = getStrings();
  container.innerHTML = `
    <div class="screen onboarding-screen">
      <h2>${s.onboarding.title}</h2>
      <p>${s.onboarding.body}</p>
      <button type="button" class="primary-btn" id="add-provider-btn">${s.onboarding.addProvider}</button>
      ${languageToggleHtml()}
    </div>
  `;

  container.querySelector("#add-provider-btn")?.addEventListener("click", handlers.onAddProvider);
  wireLanguageToggleButtons(container, handlers.onChanged);
}
